export enum EzPayStatus {
	NoAccess = 0,
	EzPay = 1,
	PromptPay = 3,
}